<div class="row align-items-center">
  <div class="col-1">
    <input class="form-check-input mb-0" type="checkbox" [id]="'check_' + dataset.filename | lowercase" [disabled]="is_loading == true || (dataset.status == '-' || dataset.status == 'Submitted'|| dataset.status =='Rejected')" (change)="checkbox_selected()" [(ngModel)]="dataset.selected">
  </div>
  <div class="col-5 text-truncate">
    <label class="form-label m-0" [for]="'check_' + dataset.filename | lowercase" [ngClass]="{'text-dark': (is_dark_mode == 'false') && dataset.status === 'Approved','text-light': (is_dark_mode == 'true') && dataset.status === 'Approved','text-muted': dataset.status !== 'Approved'}"><b>{{ dataset.filename }}</b></label>
  </div>
  <div class="col-2">
    <div class="d-flex align-items-center justify-content-center w-100">
      <button class="btn btn-sm" [ngClass]="dataset.status == 'Rejected' || dataset.status == '-' && dataset.filename.substring(0,15) == 'export_requests'? 'btn-outline-primary'  : dataset.status == '-' && dataset.filename.substring(0,15) !== 'export_requests'? 'btn-outline-light' : 'btn-outline-secondary'" [disabled]="is_loading == true || dataset.status == 'Approved' || dataset.status == '-' && dataset.filename.substring(0,15) !== 'export_requests'"(click)="toggle_export_request()">
        <i class="fa-solid fa-file-export"></i>
      </button>
    </div>
  </div>
  <div class="col-2 text-center">
    @if (is_loading == true) {
      <i class="fa-solid fa-spinner fa-spin me-2"></i> <small>loading...</small>
    } @else {
      <p class="m-0" [ngClass]="{'text-muted' : dataset.status == 'Submitted', 'text-success' : dataset.status == 'Approved', 'text-danger' : dataset.status == 'Rejected'}"><b>{{ dataset.status || '-'}}</b></p>
    }
  </div>
  <div class="col-2 text-center">
    @if (is_loading == true) {
      <i class="fa-solid fa-spinner fa-spin me-2"></i> <small>loading...</small>
    } @else {
      <p class="m-0">{{ dataset.date.toLocaleString() }}</p>
    }
  </div>
</div>